export enum TimeType {
  Hours = 'hours',
  Minutes = 'minutes'
}
